'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = OptionHeader;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _emailStyleTools = require('helpers/emailStyleTools');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function OptionHeader(props) {
  var containerStyle = props.containerStyle,
      textStyle = props.textStyle,
      text = props.text,
      URL = props.URL,
      isActive = props.isActive,
      t = props.t;

  var URLexist = URL ? 'http://www.vfmii.net/exc/aspquery?command=invoke&ipid=' + URL + '&pop=N&ripid=galileo&tpl=490&ids=59465' : null;

  return _react2.default.createElement(
    'table',
    { style: _emailStyleTools.fullMinimal, 'data-component': 'OptionHeader' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: (0, _extends3.default)({}, containerStyle, _emailStyleTools.padTen) },
          _react2.default.createElement(
            'table',
            { style: _emailStyleTools.fullMinimal, 'data-component': 'OptionHeader__Sub' },
            _react2.default.createElement(
              'tbody',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  { style: _emailStyleTools.noPad },
                  _react2.default.createElement(
                    'span',
                    { style: textStyle },
                    text
                  )
                ),
                URLexist && isActive && _react2.default.createElement(
                  'td',
                  { style: (0, _extends3.default)({}, _emailStyleTools.noPad, _emailStyleTools.right) },
                  _react2.default.createElement(
                    'span',
                    { style: textStyle },
                    _react2.default.createElement(
                      'a',
                      { style: _emailStyleTools.link, href: URLexist, rel: 'noopener noreferrer', target: '_blank' },
                      t('hotel.img')
                    )
                  )
                )
              )
            )
          )
        )
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Hotel/Email/Active/HotelOptionHeader.jsx
// module id = 1525
// module chunks = 0